<!--暂存落地管理-->
<template>
    <div>
        <Panel title="数据落地查询">
            <template slot="buttons">
                <el-button title="查询" class="blue" @click="query()" icon="el-icon-fa-search">查询</el-button>
                <el-button title="重置" class="yellow" @click="pageTable.handleReset()" icon="el-icon-fa-undo">重置</el-button>
            </template>
            <el-form :model="pageTable.param" ref="queryForm">
                <el-row>
                    <el-col :lg='8' :sm='12'>
                        <el-form-item label="接收时间">
                            <el-date-picker v-model="pageTable.param.ms_stime_range" type="datetimerange" placeholder="选择日期范围"
                                            :picker-options="UsualConfig.pickerOptionsQuickSelect">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :lg='8' :sm='12'>
                        <el-form-item label="发送时间">
                            <el-date-picker style="width: 100%;" v-model="pageTable.param.ms_ptime_range" type="datetimerange"
                                            placeholder="选择时间范围" :picker-options="UsualConfig.pickerOptionsQuickSelect">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :lg='4' :sm='12'>
                        <el-form-item prop="ms_pid" label="报文编号">
                            <el-input v-model="pageTable.param.ms_pid"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg='4' :sm='12'>
                        <el-form-item prop="ms_type" label="报文类型">
                            <el-input v-model="pageTable.param.ms_type"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :lg='4' :sm='12'>
                        <el-form-item prop="ms_name" label="报文名称">
                            <el-input v-model="pageTable.param.ms_name"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg='4' :sm='12'>
                        <el-form-item class="flex-1" label="责任链">
                            <el-select filterable v-model="pageTable.param.rc_uuid" placeholder="请选择" clearable>
                                <el-option v-for="item in spoptions" :key="item.id" :label="item.text" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg='4' :sm='12'>
                        <el-form-item prop="cs_uuid" label="消息来源">
                            <el-select filterable v-model="pageTable.param.cs_uuid" placeholder="请选择" clearable>
                                <el-option v-for="item in csoptions" :key="item.id" :label="item.text" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg='4' :sm='12'>
                        <el-form-item prop="pd_uuid" label="消息终点">
                            <el-select filterable v-model="pageTable.param.pd_uuid" placeholder="请选择" clearable>
                                <el-option v-for="item in pdoptions" :key="item.id" :label="item.text" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg='4' :sm='12'>
                        <el-form-item prop="ms_status" label="处理状态">
                            <el-select filterable placeholder="状态" v-sys-code="'msstatus'" v-model="pageTable.param.ms_status" clearable>
                                <el-option v-for="item in sysCode.msstatus" :key="item.key" :label="item.label"
                                           :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </Panel>
        <Panel title="数据落地列表">
            <template slot="buttons">
                <el-button title="删除选定" class="red" @click="doSeleDel" icon="el-icon-fa-trash">删除选定</el-button>
                <el-button title="选定重发" class="green" @click="doSeleSend" icon="el-icon-fa-refresh">选定重发</el-button>
                <el-button title="范围重发" class="green" @click="doSeleSendByRange" icon="el-icon-fa-refresh">范围重发</el-button>
            </template>

            <el-table highlight-current-row stripe border :data="pageTable.data" v-loading="pageTable.isLoading"
                      ref="table" @selection-change="handleSelectionChange" element-loading-spinner="el-icon-loading"
                      element-loading-text="数据加载中" height="calc(100vh - 344px)" @sort-change="handleSorted">
                <el-table-column prop="$rownum" label="NO." width="70" align="center" fixed/>
                <el-table-column type="selection" align='center' width="50" fixed></el-table-column>
                <el-table-column prop="mspid" label="报文编号" sortable='custom' fixed width='230px' show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-button @click="doMsEdit(scope.row.uuid)">{{ scope.row.mspid }}</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="cs_name" label="消息来源" sortable='custom' fixed width='170px' show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-button @click="doCsEdit(scope.row.csuuid)">{{ scope.row.cs_name }}</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="pd_name" label="消息终点" sortable='custom' fixed width='170px' show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-button @click="doPdEdit(scope.row.pduuid)">{{ scope.row.pd_name }}</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="sp_defn" label="责任链" sortable='custom' min-width='90px' show-overflow-tooltip>
                    <template slot-scope="scope" v-if="scope.row.sp_defn">
                        <el-button @click="doSpEdit(scope.row.spuuid)">{{ scope.row.sp_defn }}</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="mstype" label="报文类型" sortable='custom' min-width='100px'></el-table-column>
                <el-table-column prop="msname" label="报文名称" sortable='custom' min-width='150px' show-overflow-tooltip>
                    <!-- <template slot-scope="scope">
                      {{getShort(scope.row.msname)}}
                    </template> -->
                </el-table-column>
                <el-table-column prop="mssender" label="发送者" sortable='custom' min-width='100px' show-overflow-tooltip></el-table-column>
                <el-table-column prop="msrecver" label="接收者" sortable='custom' min-width='100px' show-overflow-tooltip></el-table-column>
                <el-table-column prop="msstanode" label="起始节点" sortable='custom' min-width='100px' show-overflow-tooltip></el-table-column>
                <el-table-column prop="msendnode" label="终止节点" sortable='custom' min-width='100px' show-overflow-tooltip></el-table-column>
                <el-table-column prop="msstime" label="接收时间" :formatter="formatterDateTime" sortable='custom' width='150'></el-table-column>
                <el-table-column prop="msptime" label="发送时间" :formatter="formatterDateTime" sortable='custom' width='150'></el-table-column>
                <el-table-column prop="msotime" label="报文时间" :formatter="formatterDateTime" sortable='custom' width='150'></el-table-column>
                <el-table-column prop="msstatus" label="处理状态" min-width='100px' show-overflow-tooltip>
                    <template slot-scope="scope">
                        <SysCode :type="'msstatus'" :value="scope.row.msstatus"></SysCode>
                    </template>
                </el-table-column>
                <el-table-column prop="msrenum" label="重发次数" sortable='custom' min-width='100px'></el-table-column>

            </el-table>
            <export-ctrl class="pull-left" @export="pageTable.handleExport($event, $refs.table)"/>
            <el-pagination background :page-size.sync="pageTable.size" :current-page.sync="pageTable.curr" :total="pageTable.total"/>
        </Panel>

        <el-dialog close-on-press-escape append-to-body v-draggable :visible.sync="editor.show" title="责任链明细" width="800px" height="400px">
            <div v-if="editor.show">
                <RcEdit v-if="editor.show" ref="edit" :datsp='spdata'></RcEdit>
            </div>
        </el-dialog>

        <el-dialog close-on-press-escape append-to-body v-draggable :visible.sync="editorpd.show" title="生产者明细" width="800px"
                   height="400px">
            <div v-if="editorpd.show">
                <PdEdit v-if="editorpd.show" ref="edit" :datpd='pddata'></PdEdit>
            </div>
        </el-dialog>

        <el-dialog close-on-press-escape append-to-body v-draggable :visible.sync="editorcs.show" title="消费者明细" width="800px"
                   height="400px">
            <div v-if="editorcs.show">
                <CsEdit v-if="editorcs.show" ref="edit" :datcs='csdata'></CsEdit>
            </div>
        </el-dialog>

        <el-dialog close-on-press-escape append-to-body v-draggable :visible.sync="editorms.show" title="报文明细" width="800px" height="400px">
            <div v-if="editorms.show">
                <MsEdit v-if="editorms.show" ref="edit" :datms='msdata' :uuid='msuuid'></MsEdit>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import CommonApi from "@/api/Common";
import perTmpApi from "./PerTmp";
import RcEdit from "./persistent/RcInfo";
import PdEdit from "./persistent/PdEditor";
import CsEdit from "./persistent/CsEditor";
import MsEdit from "./persistent/MsInfo";
import {PageTable, UsualConfig} from 'cnetong-core-frontend';

export default {
    name: "PersistentTmp",
    components: {RcEdit, PdEdit, CsEdit, MsEdit},
    data() {
        return {
            pageTable: new PageTable({
                autoLoad: true,
                doLoad: perTmpApi.queryPersistenTmp,
                param: {
                    ms_stime_range: [new Date(new Date(new Date().setHours(0)).setMinutes(0)).setSeconds(0),
                        new Date(new Date(new Date().setHours(23)).setMinutes(59)).setSeconds(59)],
                    orderField: 'ms_stime',
                    orderDirection: 'desc',
                }
            }),
            UsualConfig,

            table: {
                data: []
            },
            send_time: [],
            csoptions: [],
            pdoptions: [],
            spoptions: [],
            editor: {
                show: false,
                loading: false
            },
            editorpd: {
                show: false,
                loading: false
            },
            editorcs: {
                show: false,
                loading: false
            },
            editorms: {
                show: false,
                loading: false,
                uuid: ""
            },
            spdata: [],
            pddata: [],
            csdata: [],
            msdata: [],
            msuuid: "",
            multipleSelection: []
        };
    },
    mounted() {
        this.loadInfo();
    },
    methods: {
        query() {
            if (!this.pageTable.param.ms_stime_range) {

            }

            this.pageTable.handleLoad();
        },
        getShort(value) {
            return value.substring(0, 100);
        },
        // 发送终端信息页面
        doMsEdit(uuid) {
            this.getMsMould(uuid).then(this.openmsDialog);
        },
        openmsDialog() {
            this.loading = true;
            this.editorms.show = true;
            this.loading = false;
        },
        getMsMould(uuid) {
            this.msuuid = uuid;
            return perTmpApi.getMs(uuid).then(respData => {
                this.msdata = respData;
            });

            // return perTmpApi.getMs(uuid);
        },

        // 发送终端信息页面
        doCsEdit(csuuid) {
            this.getCsMould(csuuid).then(this.opencsDialog);
        },
        opencsDialog() {
            this.loading = true;
            this.editorcs.show = true;
            this.loading = false;
        },
        getCsMould(csuuid) {
            return perTmpApi.getCs(csuuid).then(respData => {
                this.csdata = respData;
            });
        },

        // 发送终端信息页面
        doPdEdit(pduuid) {
            this.getPdMould(pduuid).then(this.openpdDialog);
        },
        openpdDialog() {
            this.loading = true;
            this.editorpd.show = true;
            this.loading = false;
        },
        getPdMould(pduuid) {
            return perTmpApi.getPd(pduuid).then(respData => {
                this.pddata = respData;
            });
        },

        // 责任量信息页面
        doSpEdit(spuuid) {
            this.getJsonMould(spuuid).then(this.openDialog);
        },
        openDialog() {
            this.loading = true;
            this.editor.show = true;
            this.loading = false;
        },
        getJsonMould(spuuid) {
            return perTmpApi.getSp(spuuid).then(respData => {
                this.spdata = respData.datas;
            });
        },
        // 范围重发
        async doSeleSendByRange() {
            try {
                await this.confirm();
                this.pageTable.isLoading = true;
                await perTmpApi.sendTmpByRange(this.pageTable.param);
                this.query();
            } finally {
                this.pageTable.isLoading = false;
            }
        },

        // 选定重发
        async doSeleSend() {
            if (this.multipleSelection.length === 0) {
                this.$message.warning("请选择数据！");
                return;
            }
            try {
                await this.confirm();
                this.pageTable.isLoading = true;
                let array = this.multipleSelection.map(v => v.uuid);
                await perTmpApi.sendTmp(array);
                this.query();
            } finally {
                this.pageTable.isLoading = false;
            }
        },
        async doSeleDel() {
            if (this.multipleSelection.length === 0) {
                this.$message.warning("请选择数据！");
                return;
            }
            try {
                await this.confirm();
                this.pageTable.isLoading = true;
                let array = this.multipleSelection.map(v => v.uuid);
                await perTmpApi.delTmp(array);
                this.query();
            } finally {
                this.pageTable.isLoading = false;
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // column中获取接收终端名字
        getCsName(id) {
            let idx = this.csoptions.findIndex(v => v.id === id);
            return idx === -1 ? '' : this.csoptions[idx].text;
        },
        // column中获取发送终端名字
        getPdName(id) {
            let idx = this.pdoptions.findIndex(v => v.id === id);
            return idx === -1 ? '' : this.pdoptions[idx].text;
        },
        getSpName(id) {
            let idx = this.spoptions.findIndex(v => v.id === id);
            return idx === -1 ? '' : this.spoptions[idx].text
        },
        async loadInfo() {
            let resp = await CommonApi.initList();
            this.csoptions = resp.csList;
            this.pdoptions = resp.pdList;
            this.spoptions = resp.rpbChainList;
        },
        // queryTmpData() {
        //     if (this.re_time && this.re_time.length > 0) {
        //         this.queryForm.startMs_stime = this.re_time[0].getTime();
        //         this.queryForm.endMs_stime = this.re_time[1].getTime();
        //         if (this.send_time && this.send_time.length > 0) {
        //             this.queryForm.startMs_ptime = this.send_time[0].getTime();
        //             this.queryForm.endMs_ptime = this.send_time[1].getTime();
        //         } else {
        //             this.queryForm.startMs_ptime = "";
        //             this.queryForm.endMs_ptime = "";
        //         }
        //         this.$refs.dataTable.load(this.queryForm);
        //     } else {
        //         this.$message({
        //             message: "请选择接收时间！",
        //             type: "warning"
        //         });
        //         return false;
        //     }
        // },
        handleSorted({column, prop, order}) {
            if (!order) {
                this.pageTable.param.orderDirection = 'desc';
                this.pageTable.param.orderField = 'ms_stime';
                this.query();
                return;
            } else if (order === "ascending") {
                this.pageTable.param.orderDirection = "asc";
            } else if (order === "descending") {
                this.pageTable.param.orderDirection = "desc";
            }

            if (prop === "msstime") {
                this.pageTable.param.orderField = "ms_stime";
            } else if (prop === "mspid") {
                this.pageTable.param.orderField = "ms_pid";
            } else if (prop === "mstype") {
                this.pageTable.param.orderField = "ms_type";
            } else if (prop === "msname") {
                this.pageTable.param.orderField = "ms_name";
            } else if (prop === "spdefn") {
                this.pageTable.param.orderField = "sp_defn";
            } else if (prop === "mssender") {
                this.pageTable.param.orderField = "ms_sender";
            } else if (prop === "msrecver") {
                this.pageTable.param.orderField = "ms_recver";
            } else if (prop === "msstanode") {
                this.pageTable.param.orderField = "ms_stanode";
            } else if (prop === "msendnode") {
                this.pageTable.param.orderField = "ms_endnode";
            } else if (prop === "msptime") {
                this.pageTable.param.orderField = "ms_ptime";
            } else if (prop === "msotime") {
                this.pageTable.param.orderField = "ms_otime";
            } else if (prop === "msstatus") {
                this.pageTable.param.orderField = "ms_status";
            } else if (prop === "msrenum") {
                this.pageTable.param.orderField = "ms_renum";
            } else if (prop === "cs_name") {
                this.pageTable.param.orderField = "cs_defn";
            } else if (prop === "pd_name") {
                this.pageTable.param.orderField = "pd_defn";
            }

            this.query();
        },
        // dataTableLoad(params, resolve) {
        //
        //     if (typeof params.cs_uuid != "undefined") {
        //         // alert("is defined");
        //     } else {
        //         params.cs_uuid = "";
        //         // params.endMs_ptime;
        //         params.endMs_stime = new Date();
        //         params.ms_pid = "";
        //         params.ms_status = "";
        //         params.pd_uuid = "";
        //         // params.startMs_ptime;
        //         params.startMs_stime = new Date() - 3600000;
        //     }
        //     perTmpApi
        //         .queryPersistenTmp(params)
        //         .then(resolve)
        //         .then(respData => {
        //             this.table.data = respData.datarows;
        //         });
        // },
    }
};
</script>
